import { defineStore } from "pinia";
import { CONNECTION_ERROR_MESSAGE } from "~/consts/common";

export const useErrorStore = defineStore("ErrorStore", () => {
  const isOpen = ref(false);
  const dialogMessage = ref<string>("");
  const buttonTitle = ref<string>("");
  let complete = () => {};

  const show = (message: string, button: string, completed: () => void) => {
    dialogMessage.value = message;
    buttonTitle.value = button;
    isOpen.value = true;
    complete = completed;
  };

  const showConnectionError = (message: string) => {
    if (isSentrySampled(useRuntimeConfig().public.appEnv === "production")) {
      sentryWarnLog(`ErrorStore.showConnectionError: ${message}`);
    }
    show(CONNECTION_ERROR_MESSAGE, "再試行", () => {
      location.reload();
    });
  };

  const showInvalidContents = (message: string) => {
    if (isSentrySampled(useRuntimeConfig().public.appEnv === "production")) {
      sentryWarnLog(`ErrorStore.showConnectionError: ${message}`);
    }
    show("無効なURLです", "トップへ", () => {
      // リロードしながらホームに戻る
      reloadNuxtApp({
        path: "/",
        ttl: 1000, // デフォルト 10000
      });
    });
  };

  const close = () => {
    complete();
    isOpen.value = false;
  };

  const reset = () => {
    isOpen.value = false;
  };

  return {
    isOpen,
    dialogMessage,
    buttonTitle,
    show,
    showConnectionError,
    showInvalidContents,
    close,
    reset,
  };
});
